export default __webpack_public_path__ + "static/media/relative-faux-book-pro.88b76398.eot";